<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            地区管理
        </div>
        <div style="padding: 20px;">

            <div>

                <!-- <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                </el-row> -->

                <div style="height: 10px;"></div>

                <div :style="contentStyleObj">
                    <template>
                        <el-tree
                                v-loading="loading"
                                :props="props"
                                ref="asyncTree"
                                :load="loadNode"
                                node-key="areaCode"
                                lazy
                                :expand-on-click-node="false">

                          <span class="custom-tree-node" slot-scope="{ node, data }">

                            <span  style="width:100%">
                                <div style="width:200px;float: left;">
                                    <span class="sp">名称：{{ data.name }}</span>
                                </div>
                                <el-row style="width:800px;float: right;">
                                    <el-col :span="12" class="item">
                                        <span class="sp">等级：{{ data.level }}</span>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <span class="sp">状态：{{ getStatus(data.status) }}</span>
                                    </el-col>
                                </el-row>
                            </span>

                            <span>
                                <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="() => append(node)"></el-button>
                                <el-button type="text" size="small" icon="el-icon-edit" @click="() => updateMune(node)"></el-button>
                                <!-- <el-button type="text" size="mini" icon="el-icon-delete" @click="() => remove(node,data)"></el-button> -->
                            </span>

                          </span>
                        </el-tree>
                    </template>
                </div>

            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:listMenuDTO="listMenuDTO"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:listMenuDTO="listMenuDTO" v-on:closeEdit="closeEdit" ></Edit>
        <!-- <Sort ref="mySort" v-show="showModalSort" v-bind:listMenuDTO="listMenuDTO"  v-on:closeSort="closeSort"  v-on:menuShow="menuShow"></Sort> -->

    </div>
</template>

<script>

    import Add from "./Add";
    import Edit from "./Edit";
    // import Sort from "./Sort";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    export default {
        name: "List",
        components:{
            Add,Edit
        },
        data() {
            return {
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                showModalSort:false,
                countTime:0,
                item:'',
                parentAreaCode:'00000000-0000-0000-0000-000000000000',
                listMenuDTO:[{areaCode:"00000000-0000-0000-0000-000000000000",name:'所有地区',level:0,status:0,children:[]}],
                th:0,
                contentStyleObj: {
                    padding:'0px',
                    backgroundColor:'#fff',
                    overflowY:'auto',
                    height: ''
                },
                props: {
                    label: 'name',
                    children: 'children',
                    isLeaf: 'leaf'
                },
            }
        },
        created(){
            this.th = this.$store.state.tableHeight;
            this.contentStyleObj.height = this.th +50 +"px";
            this.loading=true
            this.menuShow()
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
                this.contentStyleObj.height = this.th+50 +"px";
            },
        },


        methods:{
            loadNode(node, resolve) {
                console.log(node.level)
                if (node.level === 0) {
                    // this.parentAreaCode='00000000-0000-0000-0000-000000000000'
                    // console.log(this.listMenuDTO)
                    // var showTimeInterval=setInterval(() => {
                    //     this.countTime++
                    //     if(this.listMenuDTO.length>0){
                    //         clearInterval(showTimeInterval);

                    //     }
                    //     if(this.countTime>400){
                    //         this.$message('数据加载超时！');
                    //         clearInterval(showTimeInterval);
                    //     }
                    // },50);
                    return resolve(this.listMenuDTO);
                }else{
                    this.parentAreaCode=node.data.areaCode
                    this.menuShow(resolve)
                }
            },
            menuShow(resolve){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Area/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        parentAreaCode:this.parentAreaCode
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.loading = false;
                            var listMenuDTO = response.data.data;
                            let aa =  JSON.stringify(listMenuDTO).replace(/listAreaDTO/g,"children");
                            this.listMenuDTO = JSON.parse(aa);
                            if(resolve){
                                resolve(listMenuDTO)
                            }
                            console.log(this.listMenuDTO);
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }

                    }
                )
            },
            getStatus(data){
                if(data==1){
                    return '禁用'
                }
                if(data==0){
                    return '正常'
                }
            },
            toggleModalAdd:function(){
                this.item = '';
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init('');
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                if(this.item){
                    let node = this.$refs.asyncTree.getNode(this.item.data.areaCode); // 通过节点id找到对应树节点对象
                    node.loaded = false;
                    node.expand();
                }

            },

            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
                if(this.item){
                    let node = this.$refs.asyncTree.getNode(this.item.data.parentAreaCode); // 通过节点id找到对应树节点对象
                    node.loaded = false;
                    node.expand();
                }
            },

            append(node) {
                this.item = node;
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(node.data.areaCode);

            },
            updateMune(node){
                this.item = node;
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(node.data)
            },
            sortMune(){
                console.log();
                this.showModalSort = !this.showModalSort;
                this.$refs.mySort.init()
            },
            remove(node, data) {
                this.$confirm('删除该菜单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const parent = node.parent;
                    const children = parent.data.children || parent.data;
                    const index = children.findIndex(d => d.menuCode === data.menuCode);
                    console.log(index);
                    children.splice(index, 1);
                    console.log(JSON.stringify(this.listMenuDTO));
                    this.save();
                }).catch(() => {
                    this.$message({type: 'info', message: '已取消删除'});
                });
            },
        },

    }

</script>


<style>

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding-right: 8px;
    }
    .el-button--text{
        font-size: 16px;
    }
    .el-tree-node__content{
        height: auto;
    }
    .sp{
        margin-right: 20px;
    }


</style>

